export const updatedIndexList = (streamData, data) => {
    if (data.length > 0) {
        return data.map((z) => {
            if (z.symbol === streamData.symbol) {
                return Object.assign(Object.assign({}, z), { lastTradedPrice: streamData.curPrice, change: streamData.changePrice, changePercentage: streamData.changePercentage });
            }
            return z;
        });
    }
};
